import { FC, useEffect, useState } from "react";
import "./SidebarPaymentsFilter.scss";
import SidebarFilter from "../../../SidebarFilter/SidebarFilter";
import { useForm } from "react-hook-form";
import { Col, FormGroup, Row } from "react-bootstrap";
import ReactSelect from "react-select";
import { customStyles } from "../../../../models/SelectCustomStyles";
import { usePayments } from "../../../../providers/Financial/Payments/PaymentsProvider";
import { PaymentsService } from "../../../../services/Financial/Payments/PaymentsServices";
import InputSearchPartner from "../../../InputSearchPartner/InputSearchPartner";

interface SidebarPaymentsFilterProps {}

export const defaultValues = {
  user: "",
  payment_date: "",
  payment_date_from: "",
  payment_date_to: "",
  plan_payment_status_id: "",
  plan_payment_method_id: "",
} as any;

const SidebarPaymentsFilter: FC<SidebarPaymentsFilterProps> = () => {
  const [valuePartner, setValuePartner] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<any>("");
  const [selectedMethod, setSelectedMethod] = useState<any>("");
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [methodOptions, setMethodOptions] = useState<any[]>([]);

  const { setParams } = usePayments();
  const { handleSubmit, setValue, register, control } = useForm<any>({ defaultValues });

  useEffect(() => {
    const loadOptions = async () => {
      const paymentsService = new PaymentsService();

      const [statusRes] = await paymentsService.listStatus({ withPaginate: false });
      const statusItems = statusRes?.data?.items || statusRes?.data || [];
      if (statusItems?.length > 0) {
        setStatusOptions([
          { value: "", label: "Todos" },
          ...statusItems.map((s: any) => ({ value: s.id, label: s.name })),
        ]);
      }

      const [methodsRes] = await paymentsService.listMethods({ withPaginate: false });
      const methodItems = methodsRes?.data?.items || methodsRes?.data || [];
      if (methodItems?.length > 0) {
        setMethodOptions([
          { value: "", label: "Todos" },
          ...methodItems.map((m: any) => ({ value: m.id, label: m.name })),
        ]);
      }
    };

    loadOptions();
  }, []);

  const onSubmit = async (data: any) => {
    // "Data do Pagamento" filters by the full day: converts a date-only input
    // to a datetime range (00:00:00 → 23:59:59) so the backend matches any
    // payment that occurred on that day regardless of the stored time component.
    const exactDate = data?.payment_date || null;
    const rawFilter: Record<string, any> = {
      user_id: data?.user?.value || null,
      payment_date_from: exactDate
        ? `${exactDate}T00:00:00`
        : (data?.payment_date_from ? `${data.payment_date_from}T00:00:00` : null),
      payment_date_to: exactDate
        ? `${exactDate}T23:59:59`
        : (data?.payment_date_to ? `${data.payment_date_to}T23:59:59` : null),
      plan_payment_status_id: data?.plan_payment_status_id ? Number(data.plan_payment_status_id) : null,
      plan_payment_method_id: data?.plan_payment_method_id ? Number(data.plan_payment_method_id) : null,
    };

    // Remove null/undefined entries — Pydantic enum fields reject explicit null
    // when the enum type doesn't declare it as Optional in some configurations
    const filter = Object.fromEntries(
      Object.entries(rawFilter).filter(([, v]) => v !== null && v !== undefined),
    );

    setParams((prev: any) => ({
      ...prev,
      filter,
      page: 1,
      perPage: prev?.perPage ?? 10,
      withPaginate: prev?.withPaginate ?? true,
    }));
  };

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div
        className="SidebarPaymentsFilter"
        data-testid="SidebarPaymentsFilter"
      >
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label>USUÁRIO</label>
              <InputSearchPartner
                name="user"
                control={control}
                setValue={setValue}
                valuePartner={valuePartner}
                setValuePartner={setValuePartner}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="payment_date">DATA DO PAGAMENTO</label>
              <input
                type="date"
                id="payment_date"
                className="form-control"
                {...register("payment_date")}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="payment_date_from">DATA INÍCIO</label>
              <input
                type="date"
                id="payment_date_from"
                className="form-control"
                {...register("payment_date_from")}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="payment_date_to">DATA FIM</label>
              <input
                type="date"
                id="payment_date_to"
                className="form-control"
                {...register("payment_date_to")}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="plan_payment_status_id">STATUS</label>
              <ReactSelect
                isSearchable
                options={statusOptions}
                value={selectedStatus ?? ""}
                defaultValue={selectedStatus}
                placeholder="Selecione..."
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(val: any) => {
                  setValue("plan_payment_status_id", val?.value);
                  setSelectedStatus(val);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="plan_payment_method_id">MÉTODO DE PAGAMENTO</label>
              <ReactSelect
                isSearchable
                options={methodOptions}
                value={selectedMethod ?? ""}
                defaultValue={selectedMethod}
                placeholder="Selecione..."
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(val: any) => {
                  setValue("plan_payment_method_id", val?.value);
                  setSelectedMethod(val);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
};

export default SidebarPaymentsFilter;
